import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ReisekostenabrechnungenServiceModule } from '..';
import { SavedReisekostenabrechnungenFiltersComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ReisekostenabrechnungenServiceModule
  ],
  declarations: [SavedReisekostenabrechnungenFiltersComponent],
  exports: [SavedReisekostenabrechnungenFiltersComponent],

})
export class SavedReisekostenabrechnungenFiltersComponentModule { }
